// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import type { SVGProps } from 'react';

/**
 * Props communes a toutes les icones @taki/ui (set Streamline Sharp Remix :
 * viewBox 0 0 24 24, fill currentColor). La couleur suit `currentColor` : on
 * theme via la classe de texte Tailwind (ex: `text-ink-600`, `text-accent`).
 */
export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'fill' | 'stroke'> {
  /** Cote (px) de l'icone carree. Defaut 20. */
  size?: number;
}

export const DEFAULT_SIZE = 20;
